import { performRequest } from "../performRequest"



export const getDivision = (params) => {
    return performRequest("get", "api/ess/division/",params)
}

export const getPosition = (id, params) => {
    return performRequest("get", `api/ess/position/`,params)
}

export const getNationality = (params) => {
    return performRequest("get", `api/ess/nationality-list-public/`,params, false)
}

export const getDepartment = (params) => {
    return performRequest("get", `api/ess/department/`,params)
}
export const getReligion = (params) => {
    return performRequest("get", `api/ess/religion/`,params)
}

export const getReportTo = (params) => {
    return performRequest("get", `api/ess/report-to-manager/`,params)
}

export const getDocumentSubType = (params) => {
    return performRequest("get", `api/ess/documents-subtype/`,params)
}

export const getUserData = (params) => {
    let p = {
        ...params,
        sort_type:"ascend",
        sort_by:"first_name"
    }
    return performRequest("get", `api/ess/all-user/`,p)
}


//** Create S3 PRE SIGNED URL */
export const createPreSignedUrl = async(file) => {
    const type = file.name.split('.').reverse()[0]

    const response = await performRequest(
      'get',
      'api/generate-s3-url/' + '?file_type=' + type,
      {
        file_name: file.name,
      },
      false
    )
  
    return response.data
  }


// Uniform Sizes
export const getUniformSizes = (params) => {
    return performRequest("get", `api/ess/uniform/size/`,params)
}


export const getCostCenter = (params) => {
    return performRequest("get", `api/store/`, params)
}

  

export const getLeaveType = (params) => {
    return performRequest("get", `api/ess/leave-type/`, params)
}

export const getGrades = (params) => {
    return performRequest("get", `api/company/grade/`,params)
}

export const getGradeDetailsById = (id, params) => {
    return performRequest("get", `api/company/grade/${id}/`,params)
}

  
export const getNotification = ( params) => {
    return performRequest("get", `api/ess/notifications/`,params)
}

export const getRequestApproverList = ( params) => {
    return performRequest("get", `api/company/request-approver/`,params)
}

export const bulkNotificationChange = ( params) => {
    return performRequest("get", `api/ess/notifications/bulk-action/`,params)
}


export const updateNotification = (id, params) => {
    return performRequest("patch", `/api/ess/notifications/${id}/`,params)
}



export const getCompany = () => {
    return performRequest("get", "api/a/company/", {}, false)
  
}